export const REPORT_FONT_FAMILY =  "Poppins"
export const REPORT_LEGEND_FONT_SIZE =  12
export const REPORT_TOOLTIP_BODY_FONT_SIZE =  11
export const REPORT_TOOLTIP_TITLE_FONT_SIZE =  12
export const REPORT_SCALES_FONT_SIZE =  12
export const REPORT_TITLE_FONT_SIZE = 16

// placeholders
export const PLACEHOLDER_IN_TIME = "In Time";

export const PLATE_SEARCH_REPORT_FILE_NAME = "report";

export const SIGHTING_NO_LONGER_AVAILABLE = "Sighting no longer available";
export const LOCATION_NOT_AVAILABLE = "Location not available for video request";
export const VIDEO_REQUEST_TOOLTIP = "Request 1-min video";
export const WINDOW_DURATION_MS = 59 * 1000;
export const MAX_CENTER_OFFSET_RATIO = 0.15;
export const SEGMENT_DURATION_MS = 60 * 1000;
